<div class="card">
    <div class="card-header">
        Force Check Out Utility
    </div>
    <div class="card-body">
        <div class="row m-1">
            <div class="col-md-2 px-1">
                <label class="Label">Date<span class="text-danger">*</span></label>
            </div>
            <div class="col-md-3 px-1">
                <div class="input-group">
                    <input class="form-control" name="HolidayDate" placeholder="Ex. DD/MMM/YYYY" [(ngModel)]="ForceDate"
                        #HolidayDate="ngModel" ngbDatepicker #d="ngbDatepicker" [ngModelOptions]="{standalone: true}"
                        required readonly (ngModelChange)="clear()"/>
                    <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d.toggle()"
                        type="button"></button>
                    <div class="invalid-feedback">
                        Please enter date !
                    </div>
                </div>
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-2 px-1">
                <label class="Label">Branch </label>
            </div>
            <div class="col-md-4 px-1">
                <!-- <ng-select name="branch" [items]="BranchMaster" bindLabel="BranchName" bindValue="BranchMasterID"
                    [(ngModel)]="BranchId" (change)=" onSelectChange('Branch');">
                    <ng-option *ngFor="let segment of BranchMaster" [value]="segment.BranchMasterID">
                        {{ segment.BranchName }}
                    </ng-option>
                </ng-select> -->

                <ng-select [items]="BranchMaster" [multiple]="true" bindLabel="BranchName" name="muliex"
                    [selectableGroup]="false" [selectableGroupAsModel]="false" [closeOnSelect]="false"
                    bindValue="BranchMasterID" [(ngModel)]="BranchMasterIDs" placeholder="Select Branch" (change)="clear()" required>

                    <ng-template ng-header-tmp let-items="items">
                        <input type="checkbox" (change)="CheckAll($event,'Branch')" /> Check All
                    </ng-template>

                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                        <input id="item-{{index}}" name="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                            [ngModelOptions]="{ standalone : true }" />
                        {{item.BranchName}}
                    </ng-template>
                    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                        <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                            <span class="ng-value-label">{{item.BranchName}}</span>
                        </div>
                        <div class="ng-value" *ngIf="items.length > 1">
                            <span class="ng-value-label">{{items.length - 1}} +...</span>
                        </div>
                    </ng-template>
                </ng-select>
                <div class="invalid-feedback">
                    Please select Branch.
                </div>
            </div>

            <div class="col-md-2 px-1">
                <button class="btn btn-sm btn-primary" name="submit" (click)="Load()">
                    <i class="bi bi-search" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Load':'Loading...'}}
                </button>
            </div>
        </div>
        <hr>
        <div>
            <div class="card border-radius-0 mt-1 p-0">
                <div class="card-header">
                    Data
                </div>
                <div class="card-body p-1" style="overflow: auto;">
                    <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                        class="customeDatatable table table-bordered">
                        <thead class="table-light">
                            <tr>
                                <th scope="col" style="width: 5px;">#</th>
                                <th scope="col" style="width: 5px;">
                                    <input type="checkbox" (change)="selectAll($event)">
                                </th>
                                <th scope="col" style="display: none;">Branch ID</th>
                                <th scope="col" style="display: none;">Branch Code</th>
                                <th scope="col">Branch Name </th>
                                <!-- <th scope="col" style="width: 5px;">Delete</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let shift of LogData; let i = index">
                                <th scope="row" style="width: 5px;">{{ i + 1 }}</th>
                                <td style="width: 5px;">
                                    <input type="checkbox" [(ngModel)]="shift.selected" (change)="selectRow($event, shift)">
                                </td>
                                <td style="display: none;">{{ shift.BranchMasterID }}</td>
                                <td style="display: none;">{{ shift.BranchCode }}</td>
                                <td>{{ shift.BranchName }}</td>
                                <!-- <td style="width: 5px;">
                                    <button class="btn btn-sm" name="delete" style="color: red;" (click)="deleteRow(i)"><i
                                            class="bi bi-trash-fill"></i></button>
                                </td> -->
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col">
                <div class="row">
                </div>
                <div class="row">
                </div>
            </div>
            <div class="col-auto">
                <button *ngIf="this.common.PageRight.IsEdit" class="btn btn-sm btn-primary disabled-to-grey" name="checkout" (click)="Save()">
                    <i class="bi bi-box-arrow-right" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Force Check Out':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
</div>